// extracted by mini-css-extract-plugin
module.exports = {"play":"button-play_play__ZYXvB","fill":"button-play_fill__3o3aa","btn":"button-play_btn__2btIt","loading":"button-play_loading__U9uEE"};